module.exports = __webpack_public_path__ + "static/media/accedo-logo.0a9e5ea0.png";